<template>
  <div class="textarea-wrapper">
    <div
      class="textarea-block"
      :class="{
        'textarea-block--error': !!errorMessage || isTextOverflow,
      }"
    >
      <div v-show="label && !errorMessage" class="textarea-block__label">
        {{ label }}
      </div>
      <textarea ref="textarea" @input="inputHandler" />
    </div>
    <div
      v-if="!hideDetails"
      class="textarea-hints"
      :class="{
        'textarea-hints--error': !!errorMessage,
      }"
    >
      <div class="textarea-hints__left">
        {{ errorMessage }}
      </div>
      <div
        v-if="maxLength"
        class="textarea-hints__counter"
        :class="{
          'textarea-hints__counter--error': isTextOverflow,
        }"
      >
        {{ `${modelValue.length}/${maxLength}` }}
      </div>
    </div>
  </div>
</template>

<script>
/* Use composition api with textfield */

export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hint: {
      type: String,
      default: "",
    },
    maxLength: {
      type: [Number, String, null],
      default: null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      defult: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      errorMessage: "",
      isTextOverflow: false,
    };
  },
  mounted() {
    this.$refs.textarea.value = this.modelValue;
  },
  methods: {
    inputHandler(e) {
      this.checkRules(e.target.value);
    },
    checkRules(text) {
      if (this.maxLength) {
        this.isTextOverflow = text.length > this.maxLength;
      }
      this.$emit("update:modelValue", text);
      for (let i = 0; i < this.rules.length; i += 1) {
        const value = this.rules[i](text);
        if (typeof value === "string") {
          this.errorMessage = value;
          return;
        } else {
          this.errorMessage = "";
        }
      }
    },
  },
  watch: {
    persistent: {
      immediate: true,
      handler(val) {
        if (val) {
          this.checkRules(this.modelValue);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.textarea-wrapper {
  font-family: Roboto-Regular;

  .textarea-block {
    padding: 12px 15px 0px;
    position: relative;
    width: 100vw;
    height: 100px;
    overflow: hidden;
    background-color: white;
    text-align: left;

    textarea {
      font-family: Roboto-Regular;
      display: block;
      font-size: 17px;
      line-height: 20px;
      border: none;
      outline: none;
      resize: none;
      min-width: 100%;
      height: 55px;
    }

    &__label {
      font-size: 12px;
      line-height: 14px;
      color: #979797;
      margin-bottom: 7px;
    }

    &--error {
      border-top: 1px solid $colorRed;
      border-bottom: 1px solid $colorRed;
    }
  }

  .textarea-hints {
    font-family: Roboto-Regular;
    margin-top: 8px;
    font-size: 12px;
    line-height: 14px;
    padding: 0 15px 8px;
    display: flex;
    justify-content: space-between;
    color: #979797;

    &__counter {
      &--error {
        color: $colorRed;
      }
    }

    &--error {
      .textarea-hints__left {
        color: $colorRed;
      }
    }
  }
}
</style>
